import { useNavigate, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container, Badge, NavDropdown } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import { LinkContainer } from 'react-router-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import SearchBox from './SearchBox';
import logo from '../assets/logo_v1.png';

const Header = () => {
  // state.card is accessible by the name of the reducer in the store.js
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate('/login');
    } catch (error) {
      console.log(error);
    }
  };

  const navLinkClass = (path) =>
    'nav-link-custom' + (pathname === path ? ' active' : '');

  const cartCount = cartItems.reduce((acc, curr) => acc + curr.qty, 0);

  return (
    <header>
      <Navbar
        variant="dark"
        expand="md collapseOnSelect"
        style={{ backgroundColor: '#697778' }}
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand className="d-flex align-items-center">
              <img src={logo} alt="Limbism" width="65px" />
              <span className="fs-1 fs-md-2 fs-lg-1">LIMBISM</span>
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              <LinkContainer to="/">
                <Nav.Link className={navLinkClass('/')}>Gallery</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/about">
                <Nav.Link className={navLinkClass('/about')}>About</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/commissions">
                <Nav.Link className={navLinkClass('/commissions')}>
                  Commissions
                </Nav.Link>
              </LinkContainer>

              <span className="nav-divider d-none d-md-inline" />

              <SearchBox />

              <LinkContainer to="/cart">
                <Nav.Link
                  className="nav-icon-link"
                  aria-label={`Cart${cartCount ? `, ${cartCount} items` : ''}`}
                >
                  <FaShoppingCart />
                  {cartCount > 0 && (
                    <Badge pill bg="light" text="dark" className="cart-badge">
                      {cartCount}
                    </Badge>
                  )}
                </Nav.Link>
              </LinkContainer>

              {userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <LinkContainer to="/profile">
                    <NavDropdown.Item>Profile</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <LinkContainer to="/login">
                  <Nav.Link className="signin-pill">
                    <FaUser /> Sign In
                  </Nav.Link>
                </LinkContainer>
              )}
              {userInfo && userInfo.isAdmin && (
                <NavDropdown title="Admin" id="adminmenu">
                  <LinkContainer to="/admin/artworkList">
                    <NavDropdown.Item>Artworks</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/userlist">
                    <NavDropdown.Item>Users</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/orderList">
                    <NavDropdown.Item>Orders</NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
